/**
 * This utility provides a workaround for the Material-UI focus management issue
 * that causes "Cannot read properties of undefined (reading 'addEventListener')" errors
 */

// Temporarily disable addEventListener to prevent errors during initial render
export const disableFocusManager = () => {
  if (typeof window !== 'undefined') {
    // Store original methods
    window._originalAddEventListener = window.addEventListener;
    window._originalRemoveEventListener = window.removeEventListener;
    
    // Replace with safe versions that check if document exists
    window.addEventListener = (type, listener, options) => {
      if (type === 'keydown') {
        // Ignore focus manager's keydown listeners during initial render
        return;
      }
      if (window._originalAddEventListener) {
        window._originalAddEventListener(type, listener, options);
      }
    };
    
    window.removeEventListener = (type, listener, options) => {
      if (type === 'keydown') {
        // Ignore focus manager's keydown listener removal
        return;
      }
      if (window._originalRemoveEventListener) {
        window._originalRemoveEventListener(type, listener, options);
      }
    };
  }
};

// Restore original addEventListener implementation once DOM is ready
export const restoreFocusManager = () => {
  if (typeof window !== 'undefined' && 
      window._originalAddEventListener && 
      window._originalRemoveEventListener) {
    window.addEventListener = window._originalAddEventListener;
    window.removeEventListener = window._originalRemoveEventListener;
    delete window._originalAddEventListener;
    delete window._originalRemoveEventListener;
  }
};
